/** Preserve only a real, explicitly selected shoe size between separate colorway products. */
export function matchingColorwayVariant(currentVariants, selectedId, sourceIndex, targetVariants, targetIndex) {
  if (sourceIndex === '' || targetIndex === '' || !selectedId) return null;
  const selected = currentVariants.find(variant => String(variant.id) === String(selectedId));
  const size = selected?.options?.[Number(sourceIndex)];
  if (!size) return null;
  return targetVariants.find(variant => variant.options?.[Number(targetIndex)] === size)?.id || null;
}

function updateLink(link) {
  const group = link.closest('[data-colorway-list]');
  if (!group) return;
  try {
    const selectedId = new URL(location.href).searchParams.get('variant');
    const id = matchingColorwayVariant(JSON.parse(group.dataset.currentVariants), selectedId, group.dataset.sizeIndex,
      JSON.parse(link.dataset.colorwayVariants), link.dataset.sizeIndex);
    const url = new URL(link.dataset.colorwayUrl, location.origin);
    if (id) url.searchParams.set('variant', id);
    link.href = url.href;
  } catch { /* Original product URL remains available. */ }
}
if (typeof document !== 'undefined') {
  for (const event of ['pointerdown', 'focusin', 'click', 'contextmenu']) {
    document.addEventListener(event, e => {
      const link = e.target.closest?.('[data-colorway-url]');
      if (link) updateLink(link);
    }, true);
  }
}
